export default __webpack_public_path__ + "static/media/mapScreen.4d8c983e.jpg";